import * as fromUserProfileState from './user-profile-store/user-profile.state'
import * as fromConfigState from './config-store/config.state'
import * as fromPageStateState from './page-state-store/page-state.state'
import * as fromCatalogueState from './catalogue-store/catalogue.state'
import * as fromDtoState from './dto-store/dto.state'
import * as fromSettingState from './setting-store/setting.state'

export interface State {
  userProfile: fromUserProfileState.UserProfileState
  config: fromConfigState.ConfigState
  pageState: fromPageStateState.PageStateState
  catalogue: fromCatalogueState.CatalogueState
  dto: fromDtoState.DtoState
  setting: fromSettingState.SettingState
}

export const initialRootState: State = {
  userProfile: fromUserProfileState.initialState,
  config: fromConfigState.initialState,
  pageState: fromPageStateState.initialPageStateState,
  catalogue: fromCatalogueState.initialState,
  dto: fromDtoState.initialDtoState,
  setting: fromSettingState.initialState
}
